module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-7b943986.png";